<template>
    <div>
        <div class="similar-articles">
            <p class="box-title">Похожие статьи</p>
            <posts-list :posts="posts"></posts-list>
        </div>
    </div>
</template>

<script>
    import PostsList from "./PostsList";

    export default {
        name: 'related-posts',
        components: {PostsList},
        props: ['posts'],
    }

</script>


<style scoped>

</style>
